module.exports = __webpack_public_path__ + "static/media/Sana Safinaz.5de1bc8c.jpg";